import { render, staticRenderFns } from "./ComplieAudio.vue?vue&type=template&id=1a7c784e&scoped=true"
import script from "./ComplieAudio.vue?vue&type=script&lang=js"
export * from "./ComplieAudio.vue?vue&type=script&lang=js"
import style0 from "./ComplieAudio.vue?vue&type=style&index=0&id=1a7c784e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c784e",
  null
  
)

export default component.exports